if (!customElements.get('starhome-delivery')) {
  customElements.define('starhome-delivery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      document.addEventListener('variant:update', event => {
        const data = event.detail?.data;
        if (String(data?.productId) !== this.dataset.productId) return;
        const updated = data.html?.querySelector('starhome-delivery[data-product-id="' + this.dataset.productId + '"]');
        if (updated) this.replaceChildren(...Array.from(updated.childNodes).map(node => node.cloneNode(true)));
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
